var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "row-span-3 customAbout" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            hasData: !_vm.$apollo.loading,
            loading: _vm.$apollo.loading,
          },
        },
        [
          _vm.contractorDetails
            ? _c("CompanyContractorDetailedInformation", {
                attrs: {
                  certifications: _vm.user.certifications,
                  educations: _vm.user.educations,
                  experiences: _vm.user.experiences,
                  profile: _vm.profile,
                  contractorId: _vm.contractorId,
                  hasSource: _vm.source,
                  resourceCard: _vm.resourceCardInfo,
                  currentUserId: _vm.currentUserId,
                  userEmail: _vm.userEmail,
                  userPhone: _vm.userPhone,
                  rating: _vm.rating,
                  contractorUserId: _vm.contractorUserId,
                },
                on: {
                  open: _vm.showModal,
                  refresh: _vm.refreshPage,
                  refreshContractor: _vm.refreshContractor,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "startSecondaryList",
                      fn: function () {
                        return undefined
                      },
                      proxy: true,
                    },
                    {
                      key: "endSecondaryList",
                      fn: function ({ secondaryItemClasses }) {
                        return [
                          _c(
                            "CardBodyItem",
                            {
                              class: secondaryItemClasses,
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c("UILink", {
                                          staticClass: "mr-4",
                                          attrs: {
                                            routeParams:
                                              _vm.contractorProjectsLink,
                                            underline: false,
                                            content: "Clients",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex text-sm font-bold" },
                                [
                                  _c("p", { staticClass: "mr-4" }, [
                                    _vm._v(
                                      " Active: " +
                                        _vm._s(
                                          _vm.contractorDetails
                                            .activeProjectsCount
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      "Completed: " +
                                        _vm._s(
                                          _vm.contractorDetails
                                            .completedProjectsCount
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2293436609
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }